export const formatAge = (input: string | null) => {
  if (!input) return '';

  return input
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join('-');
};

export const roundToHundredths = (value: any) => {
  if (!value) return 0;
  return ((Number(value) * 100) / 100).toFixed(2);
};

export const capitalizeFirstLetter = (val: string) =>
  String(val).charAt(0).toUpperCase() + String(val).slice(1).replace(/_/g, ' ');

export const getSecondsSince = (isoTimestamp: string) => {
  const inputTime = new Date(isoTimestamp).getTime();

  return (Date.now() - inputTime) / 1000;
};

export const getSecondsUntil = (isoTimestamp: string) => {
  const inputTime = new Date(isoTimestamp).getTime();

  const secondsLeft = (inputTime - Date.now()) / 1000;

  return Math.max(0, Math.ceil(secondsLeft));
};
